// FETCH ALL FABRIC_PROJECTION
export const FETCH_FABRIC_PROJECTION_REQUEST = 'FETCH_FABRIC_PROJECTION_REQUEST';
export const FETCH_FABRIC_PROJECTION_SUCCESS = 'FETCH_FABRIC_PROJECTION_SUCCESS';
export const FETCH_FABRIC_PROJECTION_FAILURE = 'FETCH_FABRIC_PROJECTION_FAILURE';


// FETCH ALL FABRIC_PROJECTION
export const FETCH_FABRIC_PROJECTION_TYPE_DISTINCT_REQUEST = 'FETCH_FABRIC_PROJECTION_TYPE_DISTINCT_REQUEST';
export const FETCH_FABRIC_PROJECTION_TYPE_DISTINCT_SUCCESS = 'FETCH_FABRIC_PROJECTION_TYPE_DISTINCT_SUCCESS';
export const FETCH_FABRIC_PROJECTION_TYPE_DISTINCT_FAILURE = 'FETCH_FABRIC_PROJECTION_TYPE_DISTINCT_FAILURE';

// CREATE FABRIC_PROJECTION
export const CREATE_FABRIC_PROJECTION_REQUEST = 'CREATE_FABRIC_PROJECTION_REQUEST';
export const CREATE_FABRIC_PROJECTION_SUCCESS = 'CREATE_FABRIC_PROJECTION_SUCCESS';
export const CREATE_FABRIC_PROJECTION_FAILURE = 'CREATE_FABRIC_PROJECTION_FAILURE';

// FETCH SINGLE PART DATA
export const FETCH_SINGLE_FABRIC_PROJECTION_REQUEST = 'FETCH_SINGLE_FABRIC_PROJECTION_REQUEST';
export const FETCH_SINGLE_FABRIC_PROJECTION_SUCCESS = 'FETCH_SINGLE_FABRIC_PROJECTION_SUCCESS';
export const FETCH_SINGLE_FABRIC_PROJECTION_FAILURE = 'FETCH_SINGLE_FABRIC_PROJECTION_FAILURE';

// UPDATE FABRIC_PROJECTION
export const UPDATE_FABRIC_PROJECTION_REQUEST = 'UPDATE_FABRIC_PROJECTION_REQUEST';
export const UPDATE_FABRIC_PROJECTION_SUCCESS = 'UPDATE_FABRIC_PROJECTION_SUCCESS';
export const UPDATE_FABRIC_PROJECTION_FAILURE = 'UPDATE_FABRIC_PROJECTION_FAILURE';

// DELETE FABRIC_PROJECTION
export const DELETE_FABRIC_PROJECTION_REQUEST = 'DELETE_FABRIC_PROJECTION_REQUEST';
export const DELETE_FABRIC_PROJECTION_SUCCESS = 'DELETE_FABRIC_PROJECTION_SUCCESS';
export const DELETE_FABRIC_PROJECTION_FAILURE = 'DELETE_FABRIC_PROJECTION_FAILURE';

export const RESET_FABRIC_PROJECTION_INFO = 'RESET_FABRIC_PROJECTION_INFO';

export const CREATE_FABRIC_PROJECTION_FORM = 'CREATE_FABRIC_PROJECTION_FORM';

export const UPDATE_FABRIC_PROJECTION_FORM = 'UPDATE_FABRIC_PROJECTION_FORM';

export const FETCH_PRNO_REQUEST = 'FETCH_PRNO_REQUEST';
export const FETCH_PRNO_SUCCESS = 'FETCH_PRNO_SUCCESS';
export const FETCH_PRNO_FAILURE = 'FETCH_PRNO_FAILURE';

export const FETCH_COMBINED_SL_NO_SUCCESS = 'FETCH_COMBINED_SL_NO_SUCCESS';
export const FETCH_COMBINED_SL_NO_FAILURE = 'FETCH_COMBINED_SL_NO_FAILURE';
export const FETCH_COMBINED_SL_NO_REQUEST = 'FETCH_COMBINED_SL_NO_REQUEST';


export const FETCH_FABRIC_PROJECTION_INVOICE_SUCCESS = 'FETCH_FABRIC_PROJECTION_INVOICE_SUCCESS';
export const FETCH_FABRIC_PROJECTION_INVOICE_FAILURE = 'FETCH_FABRIC_PROJECTION_INVOICE_FAILURE';
export const FETCH_FABRIC_PROJECTION_INVOICE_REQUEST = 'FETCH_FABRIC_PROJECTION_INVOICE_REQUEST';


// export const UPDATE_FLD_SUBJECT = 'UPDATE_FLD_SUBJECT'; // subject validations 0407